import { load } from "@cashfreepayments/cashfree-js";

import toast from "_common/toast";

export const DEFAULT_ERROR_MSG = "Something went wrong, please try again!";

export const isCustomError = error => {
	return ( typeof error === "object" && error !== null && "displayMsg" in error );
};

export function errorHandler ( error ) {
	if ( isCustomError ( error ) ) {
		toast.error ( error.displayMsg );

		return;
	}
	toast.error ( DEFAULT_ERROR_MSG );
}

export const payViaCashfree = async paymentSessionId => {

	try {
		const cashfree = await load ( {
			mode: process.env.APP_ENV === "prod" ? "production" : "sandbox"
		} );

		const checkoutOptions = {
			paymentSessionId,
			redirectTarget: "_self"
		};

		const res = await cashfree.checkout ( checkoutOptions );

		if ( res.error ) {
			// This will be true whenever user clicks on close icon inside the modal or any error happens during the payment
			toast.error ( String ( res.error ) );
			// onCancelPayment ();
		}

		if ( res.redirect ) {
			// This will be true when the payment redirection page couldn't be opened in the same window
			// This is an exceptional case only when the page is opened inside an inAppBrowser
			// In this case the customer will be redirected to return url once payment is completed
		}

		if ( res.paymentDetails ) {
			// This will be called whenever the payment is completed irrespective of transaction status
			// onComplete ( orderId );
		}
	} catch ( error ) {
		errorHandler ( error );
	}
};
